import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'departamentos',
})
export class DepartamentosPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (items) {

      if (filter['id_local']) {

        items = items.filter((item) => item.ids_locales.includes(filter['id_local']));

      }

      return items;

    }

  }

}



// WEBPACK FOOTER //
// ./src/pipes/departamentos/departamentos.ts